module.exports = __webpack_public_path__ + "static/k-bites-menu-806011ee9a318a4f77159693b4abf38b.jpg";